import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getTranslationProofsOptions,
  useDeleteTranslationProof,
  useUploadOrUpdateTranslationProof,
} from './model/TranslationProofModel';

interface TranslationProofActionProps {
  translationId: number;
  authors: Author[];
  variant?: 'compact';
}

export function TranslationProofAction({ translationId, authors }: TranslationProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getTranslationProofsOptions(translationId));
  const uploadOrUpdateMutation = useUploadOrUpdateTranslationProof(translationId);
  const deleteMutation = useDeleteTranslationProof(translationId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="translation"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
